<template>
  <div class="section_w patientInfoSection_view">
    <KvTable :items="items"/>
  </div>
</template>

<script>
import KvTable from '@/components/Table/kvTable';
import {
  _BRAIN_LESION_RANGE,
} from "@/components/Table/static";
import {mapGetters} from "vuex";

export default {
  props: [
    'modifyPatientProps',
  ],
  components: {
    KvTable,
  },
  data() {
    const height = this.$store.state.unit === 'metric' ?
        parseFloat(parseFloat(this.modifyPatientProps.patientInfo.patientInfoHeight).toFixed(1)) :
        parseFloat((this.modifyPatientProps.patientInfo.patientInfoHeight / 30.48).toFixed(2));
    const weight = this.$store.state.unit === 'metric' ?
        parseFloat(parseFloat(this.modifyPatientProps.patientInfo.patientInfoWeight).toFixed(1)) :
        parseFloat((this.modifyPatientProps.patientInfo.patientInfoWeight * 2.205).toFixed(2));

    const item = [
      // {
      //     index: 0,
      //     keyTitle: this.$t( 'patient.info.image' ),
      //     keyType: 'ImageSelector',
      //     class: '',
      //     keyRange: [],
      //     values: this.modifyPatientProps.patientInfo.patientInfoImageUrl
      // },
      {
        index: 0,
        keyTitle: this.$t('patient.info.email'),
        keyType: 'DefaultInfoInput',
        class: '',
        keyRange: [],
        values: this.modifyPatientProps.patientEmail
      },
      {
        index: 1,
        keyTitle: this.$t('user.name') + ' *',
        keyType: 'DefaultInput',
        class: '',
        keyRange: [],
        values: this.modifyPatientProps.patientInfo.patientInfoName,
        maxLength: 20,
      },
      {
        index: 2,
        keyTitle: this.$t('patient.info.gender.key'),
        keyType: 'GenderRadioBox',
        class: '',
        keyRange: [],
        values: this.modifyPatientProps.patientInfo.patientInfoGender
      },
      {
        index: 3,
        keyTitle: this.$t('patient.info.date_of_birth'),
        keyType: 'SingleDateInput',
        class: '',
        keyRange: [],
        componentOptions: {
          minDate: this.moment().add(-100, 'year').format(),
          maxDate: this.moment().add(-14, 'year').format(),
          popoverVisibility: 'focus',
          popoverDirection: 'bottom'
        },
        values: this.modifyPatientProps.patientInfo.patientInfoBirth ? this.moment( this.modifyPatientProps.patientInfo.patientInfoBirth ).toDate() : undefined
      },
      {
        index: 4,
        keyTitle: this.$t('patient.info.height') + ` (${this.$store.state.unit === 'metric' ? 'cm' : 'ft'})`,
        keyType: 'NumberInput',
        class: '',
        keyRange: [],
        values: height === 0 ? '' : height,
        minValue: 0,
        maxValue: this.$store.state.unit === 'metric' ? 300 : 9.84,
        unit: 'cm',
        float: this.$store.state.unit === 'metric' ? 1 : 2
      },
      {
        index: 5,
        keyTitle: this.$t('patient.info.weight') + ` (${this.$store.state.unit === 'metric' ? 'kg' : 'lb'})`,
        keyType: 'NumberInput',
        class: '',
        keyRange: [],
        values: weight === 0 ? '' : weight,
        minValue: 0,
        maxValue: this.$store.state.unit === 'metric' ? 600 : 1323,
        unit: 'kg',
        float: this.$store.state.unit === 'metric' ? 1 : 2
      },
      {
        index: 6,
        keyTitle: this.$t('patient.condition.primary_diagnosis'),
        keyType: 'DefaultInput',
        class: '',
        keyRange: [],
        values: this.modifyPatientProps.patientInfo.patientInfoPrimaryDiagnosis,
        maxLength: 30,
      },
      {
        index: 7,
        keyTitle: this.$t('patient.condition.secondary_diagnosis'),
        keyType: 'DefaultInput',
        class: '',
        keyRange: [],
        values: this.modifyPatientProps.patientInfo.patientInfoSecondaryDiagnosis,
        maxLength: 30,
      },
      {
        index: 8,
        keyTitle: this.$t('patient.condition.on_set_date'),
        keyType: 'SingleDateInput',
        class: '',
        keyRange: [],
        componentOptions: {
          maxDate: new Date(),
          popoverVisibility: 'focus',
          popoverDirection: 'top'
        },
        values: this.modifyPatientProps.patientInfo.patientInfoOccurrenceDate ? this.moment(this.modifyPatientProps.patientInfo.patientInfoOccurrenceDate).toDate() : undefined
      },
      {
        index: 9,
        keyTitle: this.$t('patient.condition.brain_lesions'),
        keyType: 'SelectBox',
        class: '',
        keyRange: this.getCheckTimeZone() ? _BRAIN_LESION_RANGE.filter(item => item.no <= 0 || item.no >= 7) : _BRAIN_LESION_RANGE.slice(0,7),
        values: _BRAIN_LESION_RANGE.find(idx => idx.no === this.modifyPatientProps.patientInfo.patientInfoBrainLesion)
      }
    ];
    return {
      items: item,
    }
  },
  methods: {
    ...mapGetters([
      'getCheckTimeZone',
    ]),
    getValue() {
      this.modifyPatientProps.patientInfo.patientInfoName = this.items[1].values;
      this.modifyPatientProps.patientInfo.patientInfoGender = this.items[2].values;
      this.modifyPatientProps.patientInfo.patientInfoBirth = this.items[3].values ?
          this.moment(this.items[3].values).format('YYYY-MM-DD') : null;
      this.modifyPatientProps.patientInfo.patientInfoHeight = this.$store.state.unit === 'metric' ?
          parseFloat(this.items[4].values) : (this.items[4].values * 30.48).toFixed(3);
      this.modifyPatientProps.patientInfo.patientInfoWeight = this.$store.state.unit === 'metric' ?
          parseFloat(this.items[5].values) : (this.items[5].values / 2.205).toFixed(3);
      this.modifyPatientProps.patientInfo.patientInfoPrimaryDiagnosis = this.items[6].values;
      this.modifyPatientProps.patientInfo.patientInfoSecondaryDiagnosis = this.items[7].values;
      this.modifyPatientProps.patientInfo.patientInfoOccurrenceDate = this.items[8].values ?
          this.moment(this.items[8].values).format('YYYY-MM-DD') : null;
      this.modifyPatientProps.patientInfo.patientInfoBrainLesion = this.items[9].values?.no ?? 0;
    }
  },
}
</script>
<style lang="scss" scoped>
.table-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px;
  width: 100%;
  text-align: left;

  .item-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.5rem;
    height: 45px;

    .item-title {
      flex: 2 1 1rem;
      font-weight: bold;
    }

    .item-value {
      flex: 3 3 1rem;
    }
  }
}
</style>